import Scene from '@scene';
import { SET_BEAM_OFFSET } from '@reducers/selectors/dimension/actions';
import { 
  SET_BRACKET_ATTACHMENT_LOAD_L, 
  SET_BRACKET_ATTACHMENT_LOAD_LG, 
  SET_BRACKET_ATTACHMENT_LOAD_F, 
  SET_BRACKET_ATTACHMENT_LOAD_NR, 
  SET_BRACKET_ATTACHMENT_WEIGHT_P, 
} from '@reducers/selectors/loads/actions';
import { mergeDeep } from '@services/helper.service';

export const SET_BEAM_SHIFT_X = 'SET_BEAM_SHIFT_X';
export const SET_BEAM_SHIFT_Y = 'SET_BEAM_SHIFT_Y';
export const SET_BEAM_SHAPE = 'SET_BEAM_SHAPE';
export const RESET_BEAM = 'RESET_BEAM';
export const SET_BEAM_ROTATION = 'SET_BEAM_ROTATION';
export const SET_BEAM_ROTATE_DIRECTION = 'SET_BEAM_ROTATE_DIRECTION';
export const SET_BEAM_HEIGHT = 'SET_BEAM_HEIGHT';
export const SET_BEAM_LOAD_LG = 'SET_BEAM_LOAD_LG';
export const SET_BEAM_LOAD_F = 'SET_BEAM_LOAD_F';
export const SET_BEAM_LOAD_NR = 'SET_BEAM_LOAD_NR';
export const SET_BEAM_WEIGHT_P = 'SET_BEAM_WEIGHT_P';
export const SET_BEAM_TYPE = 'SET_BEAM_TYPE';
export const SET_BEAM_OPTIONS = 'SET_BEAM_OPTIONS';
export const SET_BEAM_STATE = 'SET_BEAM_STATE';

/*
  Action creators
 */
export function setBeamShiftX(value) {
  return (dispatch, getState) => {
    // dispatch({ type: SET_BEAM_SHIFT_X, value });

    // Scene.updateBeam(getState().options.beam);
    dispatch(setBeamOptions({
      shift: {
        x: value
      }
    }));
  };
}
export function setBeamShiftY(value) {
  return (dispatch, getState) => {
    // dispatch({ type: SET_BEAM_SHIFT_Y, value });

    // Scene.updateBeam(getState().options.beam);
    dispatch(setBeamOptions({
      shift: {
        y: value
      }
    }));
  };
}
export function setBeamShape(value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_BEAM_SHAPE, value });

    Scene.updateBeam(getState().options.beam);
  };
}
export function resetBeam(appType) {
  return triggerUpdate({ type: RESET_BEAM, appType });
}
export function setBeamRotation(value) {
  return triggerUpdate({ type: SET_BEAM_ROTATION, value });
}
export function setBeamRotateDirection(value) {
  return triggerUpdate({ type: SET_BEAM_ROTATE_DIRECTION, value });
}

export function setBeamHeight (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_BEAM_HEIGHT, value });

    Scene.updateBeam(getState().options.beam);
  };
}
export function setBeamLoadsLg (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_BEAM_LOAD_LG, value });

    Scene.updateBeam(getState().options.beam);
  };
}
export function setBeamLoadsF (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_BEAM_LOAD_F, value });

    Scene.updateBeam(getState().options.beam);
  };
}
export function setBeamLoadsNr (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_BEAM_LOAD_NR, value });

    Scene.updateBeam(getState().options.beam);
  };
}
export function setBeamWeightP (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_BEAM_WEIGHT_P, value });

    Scene.updateBeam(getState().options.beam);
  };
}
export function setBeamType (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_BEAM_TYPE, value});

    Scene.updateBeam(getState().options.beam);
  };
}
export function setBeamOptions (options) {
  return (dispatch, getState) => {
    var value = mergeDeep({}, options); // make sure we don't delete the properties from original object due to the reference
		const isPredefinedBasePlate = (getState().selectors.application[getState().main.appType].predefinedBasePlate && 
      getState().selectors.application[getState().main.appType].predefinedBasePlate.isPredefinedBasePlate) || false;
    if (value.shift){
      if (isPredefinedBasePlate)
        delete value.shift;
      else {
        dispatch({ 
          type: SET_BEAM_OFFSET, 
          appType: getState().main.appType, 
          ex: value.shift.hasOwnProperty("x") ? value.shift.x : getState().options.beam.shift.x,
          ey: value.shift.hasOwnProperty("y") ? value.shift.y : getState().options.beam.shift.y
        });
      }
    }
    if (value.height) {
      dispatch({ type: SET_BRACKET_ATTACHMENT_LOAD_L, value: value.height });
      if (getState().selectors.loads[getState().main.appType].lg > value.height) {
        if (value.loads)
          value.loads.lg = value.loads.lg && value.loads.lg <= value.height ? value.loads.lg : value.height;
        else 
          value.loads = { lg: value.height };
      }
    }
    if (value.loads) {
      if (value.loads.lg) {
        if (value.loads.lg > getState().selectors.loads[getState().main.appType].l)
          value.loads.lg = getState().selectors.loads[getState().main.appType].l;
        dispatch({ type: SET_BRACKET_ATTACHMENT_LOAD_LG, value: value.loads.lg });
      }
      if (value.loads.loadF) {
        dispatch({ type: SET_BRACKET_ATTACHMENT_LOAD_F, value: value.loads.loadF });
      }
      if (value.loads.loadNr) {
        dispatch({ type: SET_BRACKET_ATTACHMENT_LOAD_NR, value: value.loads.loadNr });
      }
      if (value.loads.weightP) {
        dispatch({ type: SET_BRACKET_ATTACHMENT_WEIGHT_P, value: value.loads.weightP });
      }
    }

    dispatch(triggerUpdate({ type: SET_BEAM_OPTIONS, value}));
  };
}

export function setBeamState(state) {
  return (dispatch) => {
    dispatch(triggerUpdate({ type: SET_BEAM_STATE, state}));
  };
}

function triggerUpdate(event) {
  return (dispatch, getState) => {
    dispatch(event);

    Scene.updateBeam(getState().options.beam);
  };
}



// WEBPACK FOOTER //
// ./src/reducers/options/beam/actions.js